<template>
  <div>
    <b-card>
      <b-row>
        <b-col xl="6">

          <b-form-group
            label="Gravado"
            label-for="gravado"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              v-if="!readOnly"    
              id="montoGravado"
              v-model.trim= "$v.montoGravado.$model" 
              :state="montoGravadoValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"    
              id="montoGravadoValue"
              :value="montoGravado | numero(2, true)" 
              type="text"
              readonly>
            </b-form-input>

            <b-form-invalid-feedback id="montoGravadoFeedback">
              {{ montoGravadoInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          
          <b-form-group
            label="Exento"
            label-for="exento"
            :label-cols="labelCols"
            horizontal>

            <b-form-input 
              v-if="!readOnly"
              id="montoExento"
              v-model.trim= "$v.montoExento.$model" 
              :state="montoExentoValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"
              id="montoExentoValue"
              :value="montoExento | numero(2, true)" 
              type="text"
              readonly>
            </b-form-input>

            <b-form-invalid-feedback id="montoExentoFeedback">
              {{ montoExentoInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          
          <b-form-group
            v-if="montoNoGravadoVisible"
            label="No Gravado"
            label-for="noGravado"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              v-if="!readOnly"
              id="montoNoGravado"
              v-model.trim= "$v.montoNoGravado.$model" 
              :state="montoNoGravadoValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"
              id="montoNoGravadoValue"
              :value="montoNoGravado | numero(2, true)" 
              type="text"
              :readonly="readOnly">
            </b-form-input>

            <b-form-invalid-feedback id="montoNoGravadoFeedback">
              {{ montoNoGravadoInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          
          <b-form-group
            label="Subtotal"
            label-for="subtotal"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="subtotal"
              :value="montoBase" 
              type="text"
              readonly>
            </b-form-input>
          </b-form-group>
        </b-col>

        <b-col xl="6">
          <b-form-group
            label="Iva:"
            label-for="ivaInscripto"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              v-if="!readOnly"
              id="montoIvaInscripto"
              v-model.trim= "$v.montoIvaInscripto.$model" 
              :state="montoIvaInscriptoValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"
              id="montoIvaInscriptoValue"
              :value="montoIvaInscripto | numero(2, true)" 
              type="text"
              :readonly="readOnly">
            </b-form-input>
            <b-form-invalid-feedback id="montoIvaInscriptoFeedback">
              {{ montoIvaInscriptoInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          
          <b-form-group
            v-if="montoIvaNoInscriptoVisible"
            label="Iva No Inscr.:"
            label-for="ivaNoInscripto"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              v-if="!readOnly"
              id="montoIvaNoInscripto"
              v-model.trim= "$v.montoIvaNoInscripto.$model" 
              :state="montoIvaNoInscriptoValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"
              id="montoIvaNoInscriptoValue"
              :value="montoIvaNoInscripto | numero(2, true)" 
              type="text"
              :readonly="readOnly">
            </b-form-input>

            <b-form-invalid-feedback id="montoIvaNoInscriptoFeedback">
              {{ montoIvaNoInscriptoInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          
          <b-form-group
            v-if="montoPercepcionVisible"
            label="Percep. Iva:"
            label-for="montoPercepcionIva"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              v-if="!readOnly"
              id="montoPercepcionIva"
              v-model.trim= "$v.montoPercepcionIva.$model" 
              :state="montoPercepcionIvaValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"
              id="montoPercepcionIvaValue"
              :value="montoPercepcionIva | numero(2, true)" 
              type="text"
              :readonly="readOnly">
            </b-form-input>

            <b-form-invalid-feedback id="montoPercepcionIvaFeedback">
              {{ montoPercepcionIvaInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          
          <b-form-group
            v-if="montoPercepcionVisible"
            label="Percep. Ganancias:"
            label-for="montoPercepcionGanancias"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              v-if="!readOnly"
              id="montoPercepcionGanancias"
              v-model.trim= "$v.montoPercepcionGanancias.$model" 
              :state="montoPercepcionGananciasValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"
              id="montoPercepcionGananciasValue"
              :value="montoPercepcionGanancias | numero(2, true)" 
              type="text"
              :readonly="readOnly">
            </b-form-input>

            <b-form-invalid-feedback id="montoPercepcionGananciasFeedback">
              {{ montoPercepcionGananciasInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
          
          <b-form-group
            v-if="montoPercepcionVisible"
            label="Percep. IIBB"
            label-for="montoPercepcionesProvinciales"
            :label-cols="labelCols"
            horizontal>

            <b-input-group
              v-if="!readOnly">
              <b-input-group-append
                  class="filter-search-icons" 
                  @click="setPercepcionesProvinciales">
                <b-input-group-text>
                  <i class="fa fa-search"></i>
                </b-input-group-text>
              </b-input-group-append>
              <b-form-input 
                id="montoPercepcionesProvinciales"
                :value="montoPercepcionesProvinciales | numero(2, true)"
                readonly
                type="text"/>
            </b-input-group>

            <b-form-input 
              v-if="readOnly"
              id="montoPercepcionesProvinciales"
              :value="montoPercepcionesProvinciales | numero(2, true)"
              readonly
              type="text"/>
          </b-form-group>

          <b-form-group
            v-if="montoPercepcionVisible"
            label="Percep. C.I.:"
            label-for="montoPercepcionComercioIndustria"
            :label-cols="labelCols"
            description="Percepción Comercio e Industria"
            horizontal>
            <b-form-input 
              v-if="!readOnly"
              id="montoPercepcionComercioIndustria"
              v-model.trim= "$v.montoPercepcionComercioIndustria.$model" 
              :state="montoPercepcionComercioIndustriaValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"
              id="montoPercepcionComercioIndustriaValue"
              :value="montoPercepcionComercioIndustria | numero(2, true)" 
              type="text"
              :readonly="readOnly">
            </b-form-input>
            
            <b-form-invalid-feedback id="montoPercepcionComercioIndustriaFeedback">
              {{ montoPercepcionComercioIndustriaInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>

          <b-form-group
            label="Otros Impuestos:"
            label-for="montoOtrosImpuestos"
            :label-cols="labelCols"
            description="Otros Impuestos o Percepciones"
            horizontal>
            <b-form-input 
              v-if="!readOnly"
              id="montoOtrosImpuestos"
              v-model.trim= "$v.montoOtrosImpuestos.$model" 
              :state="montoOtrosImpuestosValido"
              type="text"
              @blur.native="validate">
            </b-form-input>

            <b-form-input 
              v-if="readOnly"
              id="montoOtrosImpuestosValue"
              :value="montoOtrosImpuestos | numero(2, true)" 
              type="text"
              :readonly="readOnly">
            </b-form-input>
            
            <b-form-invalid-feedback id="montoOtrosImpuestosFeedback">
              {{ montoOtrosImpuestosInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>

          <b-form-group
            label="Impuestos"
            label-for="impuestos"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="impuestos"
              :value="montoImpuestos" 
              type="text"
              readonly>
            </b-form-input>
          </b-form-group>
          
          <b-form-group
            label="Total"
            label-for="total"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="total"
              :value="montoTotal"
              type="text"
              readonly>
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-modal ref="percepcionesModal" 
        title="Percepciones de IIBB"
        header-bg-variant= "light" 
        hide-footer
        hide-header-close
        modal-class="modalABM percepcionesModal"
        lazy>
      <app-percepciones
        :percepciones="percepcionesProvinciales" 
        @updatePercepcionesProvinciales="updatePercepcionesProvinciales"
        @closePercepcionesProvinciales="closePercepcionesProvinciales">
      </app-percepciones>  
    </b-modal>
  </div>
</template>

<script>
import { decimal, minValue } from 'vuelidate/lib/validators';
import Percepciones from './Percepciones.vue'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'compra/getField',
  mutationType: 'compra/updateField',
});

export default {
  name: 'ABM',
  props: {
    noValidar: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    }, 
  },
  components: {
    appPercepciones: Percepciones
  },
  data () {
    return {
      labelCols: 3,

      montoGravadoValido: null,
      montoGravadoInvalidoMsj: '',
      montoExentoValido: null,
      montoExentoInvalidoMsj: '',
      montoNoGravadoValido: null,
      montoNoGravadoInvalidoMsj: '',
      montoIvaInscriptoValido: null,
      montoIvaInscriptoInvalidoMsj: '',
      montoIvaNoInscriptoValido: null,
      montoIvaNoInscriptoInvalidoMsj: '',
      montoPercepcionIvaValido: null,
      montoPercepcionIvaInvalidoMsj: '',
      montoPercepcionGananciasValido: null,
      montoPercepcionGananciasInvalidoMsj: '',
      montoPercepcionComercioIndustriaValido: null,
      montoPercepcionComercioIndustriaInvalidoMsj: '',
      montoOtrosImpuestosValido: null,
      montoOtrosImpuestosInvalidoMsj: ''
    }
  },
  computed: {
    ...mapFields([
      'montoGravado',
      'montoExento',
      'montoNoGravado',
      'montoIvaInscripto',
      'montoIvaNoInscripto',
      'montoPercepcionIva',
      'montoPercepcionGanancias', 
      'montoPercepcionComercioIndustria', 
      'montoPercepcionesProvinciales',
      'percepcionesProvinciales',
      'montoOtrosImpuestos',
      
      'montoNoGravadoVisible',
      'montoPercepcionVisible',
      'montoIvaNoInscriptoVisible'
    ]),
    montoBase: function () {
      var subtotal = parseFloat(this.montoGravado) 
        + parseFloat(this.montoExento)
        + parseFloat(this.montoNoGravado)

      return this.$options.filters.numero(subtotal, 2, true);
    },
    montoImpuestos: function () {
      var impuestos = parseFloat(this.montoIvaInscripto) 
        + parseFloat(this.montoIvaNoInscripto)
        + parseFloat(this.montoPercepcionIva)
        + parseFloat(this.montoPercepcionGanancias)
        + parseFloat(this.montoPercepcionComercioIndustria)
        + parseFloat(this.montoPercepcionesProvinciales)
        + parseFloat(this.montoOtrosImpuestos);

      return this.$options.filters.numero(impuestos, 2, true);
    },
    montoTotal: function () {
      var total = parseFloat(this.montoGravado) 
        + parseFloat(this.montoExento)
        + parseFloat(this.montoNoGravado)
        + parseFloat(this.montoIvaInscripto) 
        + parseFloat(this.montoIvaNoInscripto)
        + parseFloat(this.montoPercepcionIva)
        + parseFloat(this.montoPercepcionGanancias)
        + parseFloat(this.montoPercepcionComercioIndustria)
        + parseFloat(this.montoPercepcionesProvinciales)
        + parseFloat(this.montoOtrosImpuestos);

      return this.$options.filters.numero(total, 2, true);
    },
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'montoGravado' || validarTodos) {
        this.montoGravadoValido = null;
        this.montoGravadoInvalidoMsj = this.displayErrorMonto (this.$v.montoGravado.$error, 
          !this.$v.montoGravado.decimal, !this.$v.montoGravado.minValue); 
        
        if (this.montoGravadoInvalidoMsj.trim() != '') {
          this.montoGravadoValido = false;
        }
      }

      if (campo == 'montoExento' || validarTodos) {
        this.montoExentoValido = null;
        this.montoExentoInvalidoMsj = this.displayErrorMonto (this.$v.montoExento.$error, 
          !this.$v.montoExento.decimal, !this.$v.montoExento.minValue); 
        
        if (this.montoExentoInvalidoMsj.trim() != '') {
          this.montoExentoValido = false;
        }
      }

      if (campo == 'montoNoGravado' || validarTodos) {
        this.montoNoGravadoValido = null;
        this.montoNoGravadoInvalidoMsj = this.displayErrorMonto (this.$v.montoNoGravado.$error, 
          !this.$v.montoNoGravado.decimal, !this.$v.montoNoGravado.minValue); 
        
        if (this.montoNoGravadoInvalidoMsj.trim() != '') {
          this.montoNoGravadoValido = false;
        }
      }

      if (campo == 'montoIvaInscripto' || validarTodos) {
        this.montoIvaInscriptoValido = null;
        this.montoIvaInscriptoInvalidoMsj = this.displayErrorMonto (this.$v.montoIvaInscripto.$error, 
          !this.$v.montoIvaInscripto.decimal, !this.$v.montoIvaInscripto.minValue); 
        
        if (this.montoIvaInscriptoInvalidoMsj.trim() != '') {
          this.montoIvaInscriptoValido = false;
        }
      }

      if (campo == 'montoIvaNoInscripto' || validarTodos) {
        this.montoIvaNoInscriptoValido = null;
        this.montoIvaNoInscriptoInvalidoMsj = this.displayErrorMonto (this.$v.montoIvaNoInscripto.$error, 
          !this.$v.montoIvaNoInscripto.decimal, !this.$v.montoIvaNoInscripto.minValue); 
        
        if (this.montoIvaNoInscriptoInvalidoMsj.trim() != '') {
          this.montoIvaNoInscriptoValido = false;
        }
      }

      if (campo == 'montoPercepcionIva' || validarTodos) {
        this.montoPercepcionIvaValido = null;
        this.montoPercepcionIvaInvalidoMsj = this.displayErrorMonto (this.$v.montoPercepcionIva.$error, 
          !this.$v.montoPercepcionIva.decimal, !this.$v.montoPercepcionIva.minValue); 
        
        if (this.montoPercepcionIvaInvalidoMsj.trim() != '') {
          this.montoPercepcionIvaValido = false;
        }
      }

      if (campo == 'montoPercepcionGanancias' || validarTodos) {
        this.montoPercepcionGananciasValido = null;
        this.montoPercepcionGananciasInvalidoMsj = this.displayErrorMonto (this.$v.montoPercepcionGanancias.$error, 
          !this.$v.montoPercepcionGanancias.decimal, !this.$v.montoPercepcionGanancias.minValue); 
        
        if (this.montoPercepcionGananciasInvalidoMsj.trim() != '') {
          this.montoPercepcionGananciasValido = false;
        }
      }

      if (campo == 'montoPercepcionComercioIndustria' || validarTodos) {
        this.montoPercepcionComercioIndustriaValido = null;
        this.montoPercepcionComercioIndustriaInvalidoMsj = this.displayErrorMonto (this.$v.montoPercepcionComercioIndustria.$error, 
          !this.$v.montoPercepcionComercioIndustria.decimal, !this.$v.montoPercepcionComercioIndustria.minValue); 
        
        if (this.montoPercepcionComercioIndustriaInvalidoMsj.trim() != '') {
          this.montoPercepcionComercioIndustriaValido = false;
        }
      }

      if (campo == 'montoOtrosImpuestos' || validarTodos) {
        this.montoOtrosImpuestosValido = null;
        this.montoOtrosImpuestosInvalidoMsj = this.displayErrorMonto (this.$v.montoOtrosImpuestos.$error, 
          !this.$v.montoOtrosImpuestos.decimal, !this.$v.montoOtrosImpuestos.minValue); 
        
        if (this.montoOtrosImpuestosInvalidoMsj.trim() != '') {
          this.montoOtrosImpuestosValido = false;
        }
      }
    },

    setPercepcionesProvinciales() {
      this.$store.dispatch('comprapercepcionesprovinciales/inicializar', this.percepcionesProvinciales); 
      this.$refs.percepcionesModal.show();
    },
    updatePercepcionesProvinciales() {
      console.log(this.$store.getters['comprapercepcionesprovinciales/percepciones']);
      this.$store.dispatch('compra/setPercepciones', 
        this.$store.getters['comprapercepcionesprovinciales/percepciones']);
      this.$refs.percepcionesModal.hide()
    },
    closePercepcionesProvinciales() {
      this.$refs.percepcionesModal.hide()
    },
    save() {
      let save = true;

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
        save = false;
      }

      return save;
    }
  },
  validations: {
    montoGravado: { decimal, minValue: minValue(0) },
    montoNoGravado: { decimal, minValue: minValue(0) } ,
    montoExento: { decimal, minValue: minValue(0) } ,
    montoIvaInscripto: { decimal, minValue: minValue(0) },
    montoIvaNoInscripto: { decimal, minValue: minValue(0) },
    montoPercepcionIva: { decimal, minValue: minValue(0) },
    montoPercepcionGanancias: { decimal, minValue: minValue(0) },
    montoPercepcionComercioIndustria: { decimal, minValue: minValue(0) },
    montoOtrosImpuestos: { decimal, minValue: minValue(0) },
  },  
}
</script>

<style>
  /* div.percepcionesModal div.modal-dialog {
    width: 70% !important;
  } */
</style>
